module.exports = __webpack_public_path__ + "img/like_icon.bc494854.svg";